import {
  IMinimizedStop,
  IParsedRoute,
  IParsedStop,
  IRoute,
} from 'views/pages/Video/OnlineWatching/utils/parseRoutes';
import { Map } from 'react-leaflet';
import { ICluster } from 'views/components/Video/MapComponent';
import { UseMapSettings } from 'hooks/useMapSettings';
import { Dispatch, RefObject, SetStateAction } from 'react';
import { Vehicle } from '../../../../api/mobile/filters';
import { Route } from './EntitiesSearch/Modes/Modes.types';

export type Props = {
  mode: MapModes;
  current_dep?: number;
};

export type MapElements = {
  selectedRoutes: IParsedRoute[];
  selectedStops: IParsedStop[];
  minimizedStops: IMinimizedStop[];
  initialRoutes: IRoute[];
};

type MapLayerState = {
  active: boolean;
  title: string;
};

export type MapLayers = Record<'STOPS' | 'ROUTES' | 'VEHICLES', MapLayerState> &
  Partial<
    Record<'BCREGIONS' | 'BC_DEP' | 'DEPARTMENTS' | 'AGENCIES', MapLayerState>
  >;

export type ClusterProps = {
  clusters: ICluster[];
  mapSettings: UseMapSettings;
};

export type Agency = {
  ag_lat: number;
  ag_lon: number;
  agency_id: number;
  id: number;
  title: string;
  address: string;
  phone: string;
};

export type Department = {
  depot_id: number;
  td_id: number;
  td_lat: number;
  td_lon: number;
  td_name: string;
  address: string;
  phone: string;
  title: string;
};

export type Depot = {
  agency_id: number;
  depot_id: number;
  dp_lat: number;
  dp_lon: number;
  title: string;
  depot_name: string;
  address: string;
  phone: string;
};

export type AgenciesFilters = {
  agencies: Agency[];
  departments: Department[];
  depots: Depot[];
};

export type Context = {
  mapSettings: UseMapSettings;
};

export enum DetailsInfoType {
  vehicle,
  stop,
  route,
  agency,
  depot,
  department,
  bcregions,
}

export type DetailsInfoState = {
  type: DetailsInfoType;
  id: number;
} | null;

export type AddressItem = {
  coordinates: [number, number];
  name: string;
};

export type AddressesResponse = {
  class: string;
  display_name: string;
  icon: string;
  importance: number;
  lat: string;
  licence: string;
  lon: string;
  osm_id: number;
  osm_type: string;
  place_id: number;
  type: string;
}[];

export type BCRegion = {
  geojson: string;
  td_color: string;
  td_id: number;
  routes: { route_id: number; is_using: boolean }[];
  center: string;
};

export type OnSearchVehicle = (vehicle: Vehicle | null) => void;

export type MapContext = {
  layers: MapLayers;
  setLayers: Dispatch<SetStateAction<MapLayers>>;
  showLayersPopup: boolean;
  toggleShowLayersPopup: () => void;
  centerOnUser: () => void;
  showEntitiesSearchPopup: boolean;
  toggleShowEntitiesSearchPopup: () => void;
  getMapElements: (routes: number[]) => void;
  onSearchVehicles: OnSearchVehicle;
  mapSettings: UseMapSettings;
  clusters: ICluster[];
  setFilteredRoutes: (routeIds: number[]) => void;
  agenciesFilters: AgenciesFilters;
  setAgenciesFilters: Dispatch<SetStateAction<AgenciesFilters>>;
  setSelectedAgencies: (ids: number[]) => void;
  detailsInfo: DetailsInfoState;
  setDetailsInfo: Dispatch<SetStateAction<DetailsInfoState>>;
  mapRef: RefObject<Map> | null;
  mapElements: MapElements | null;
  filteredRoutes: number[];
  selectedAgencies: number[];
  routes: Route[];
  setRoutes: Dispatch<SetStateAction<Route[]>>;
  BCRegions: BCRegion[];
  isBc?: boolean;
  filteredVehicle: null | Vehicle;
};

export enum MapModes {
  default,
  departmentControl,
  currentRegion,
}

export type GeolocationData = {
  coords: {
    latitude: number;
    longitude: number;
  };
};
